import React from "react";
import resume from "./Yashwant_Resume.pdf";
import "../../assets/css/about.css";
// data
import { skills, exp_edu, social_links } from "./data.js";
export default function About() {
  return (
    <>
      <div className="flex bg-gray-900 w-fit">
        <div className="sticky top-0 hidden h-screen mx-0 rounded-r-3xl md:flex w-2/6 justify-center items-center bg-white">
          <h1 className=" text-black text-center text-5xl font-bold tracking-widest">
            & ABOUT ME
          </h1>
        </div>
        <div className="flex flex-1 flex-col gap-9 p-5 pt-9 ">
          {/* personal info */}
          <div className="flex flex-col">
            <h1 className="text-xl font-bold text-white">- PERSONAL INFOS</h1>
            <div className="flex md:flex-row flex-col md-gap-5 gap-3 p-4">
              <ul className="text-white flex flex-col gap-3">
                <li className="font-bold">
                  <span className="font-light"> First Name:</span> Yashwant
                </li>
                <li className="font-bold">
                  <span className="font-light"> Last Name: </span> Sahu
                </li>
                <li className="font-bold">
                  <span className="font-light"> Age:</span> 23yr
                </li>
                <li className="font-bold">
                  <span className="font-light"> Phone:</span> +918302043259
                </li>
              </ul>
              <ul className="text-white flex flex-col gap-3">
                <li className="font-bold">
                  <span className="font-light">Email: </span>
                  <a href="mailto:yashwantsahu3002@gmail.com">
                    {" "}
                    yashwantsahu3002@gmail.com{" "}
                  </a>
                </li>
                <li className="font-bold">
                  <span className="font-light">Languages: </span> Hindi, English
                </li>
                <li className="font-bold">
                  <span className="font-light">Nationality: </span> Indian
                </li>
                <li className="font-bold">
                  <span className="font-light">Address: </span> 72-B Raj Colony,
                  Foy Road, Ajmer
                </li>
              </ul>
            </div>
            <a href={resume} download className="w-fit">
              <button className="ml-3 flex gap-2 items-center text-white border hover:bg-yellow-500 hover:border-white hover:text-black transition-all border-yellow-500 p-2 text-l font-bold rounded-full self-start">
                Download CV
                <div className="bg-yellow-500 rounded-full p-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    className="w-4 h-4"
                  >
                    <path d="M3.375 3C2.339 3 1.5 3.84 1.5 4.875v.75c0 1.036.84 1.875 1.875 1.875h17.25c1.035 0 1.875-.84 1.875-1.875v-.75C22.5 3.839 21.66 3 20.625 3H3.375Z" />
                    <path
                      fillRule="evenodd"
                      d="m3.087 9 .54 9.176A3 3 0 0 0 6.62 21h10.757a3 3 0 0 0 2.995-2.824L20.913 9H3.087ZM12 10.5a.75.75 0 0 1 .75.75v4.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l1.72 1.72v-4.94a.75.75 0 0 1 .75-.75Z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              </button>
            </a>
          </div>
          {/* MY skills */}
          <div className="flex flex-col">
            <h1 className="text-xl font-bold text-white">- MY SKILLS</h1>
            <div className="grid md:grid-cols-3 grid-cols-2 pt-4 gap-2">
              {skills.map((skill) => (
                <Skills skill={skill} />
              ))}
            </div>
          </div>
          {/* Experience */}
          <div className="flex flex-col">
            <h1 className="text-xl font-bold text-white">
              - EXPERIENCE & EDUCATION
            </h1>
            <div className="grid md:grid-cols-2 grid-cols-1 gap-3 grid-rows-2 w-full p-4 pb-0 pt-6">
              {exp_edu.map((item) => (
                <ExperienceCard item={item} />
              ))}
            </div>
          </div>
          {/* Social Link */}
          <div className="flex flex-col h-52">
            <h1 className="text-xl font-bold text-white">- SOCIAL LINKS</h1>
            <div className="flex gap-10 md:justify-start justify-center w-full md:px-9 p-2 pt-6">
              {social_links.map((social) => (
                <SocialLink social={social} />
              ))}
            </div>
          </div>
        </div>
        <br></br>
        <br></br>
        <br></br>
      </div>
    </>
  );
}

function Skills({ skill }) {
  return (
    <div className="flex single-chart  justify-center flex-col items-center align-middle">
      <svg viewBox="0 0 36 36" className="circular-chart orange">
        <path
          className="circle-bg"
          d="M18 2.0845
a 15.9155 15.9155 0 0 1 0 31.831
a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <path
          className="circle"
          stroke-dasharray="90, 100"
          d="M18 2.0845
a 15.9155 15.9155 0 0 1 0 31.831
a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <text x="18" y="20.35" className="percentage">
          {skill.percentage}
        </text>
      </svg>
      <h1 className="text-center text-white text-xl">{skill.skill}</h1>
    </div>
  );
}

function ExperienceCard({ item }) {
  let { title, description, firm, duration, type, link } = item;
  return (
    <div className="flex gap-3  w-full text-white">
      <div className="flex">
        {/* Icon  */}
        <div>
          <div className="p-2 w-fit rounded-full bg-yellow-500">
            {type === "work" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-4 h-4"
              >
                <path
                  fillRule="evenodd"
                  d="M7.5 5.25a3 3 0 0 1 3-3h3a3 3 0 0 1 3 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0 1 12 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 0 1 7.5 5.455V5.25Zm7.5 0v.09a49.488 49.488 0 0 0-6 0v-.09a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5Zm-3 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                  clipRule="evenodd"
                />
                <path d="M3 18.4v-2.796a4.3 4.3 0 0 0 .713.31A26.226 26.226 0 0 0 12 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 0 1-6.477-.427C4.047 21.128 3 19.852 3 18.4Z" />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                className="w-4 h-4"
              >
                <path d="M11.7 2.805a.75.75 0 0 1 .6 0A60.65 60.65 0 0 1 22.83 8.72a.75.75 0 0 1-.231 1.337 49.948 49.948 0 0 0-9.902 3.912l-.003.002c-.114.06-.227.119-.34.18a.75.75 0 0 1-.707 0A50.88 50.88 0 0 0 7.5 12.173v-.224c0-.131.067-.248.172-.311a54.615 54.615 0 0 1 4.653-2.52.75.75 0 0 0-.65-1.352 56.123 56.123 0 0 0-4.78 2.589 1.858 1.858 0 0 0-.859 1.228 49.803 49.803 0 0 0-4.634-1.527.75.75 0 0 1-.231-1.337A60.653 60.653 0 0 1 11.7 2.805Z" />
                <path d="M13.06 15.473a48.45 48.45 0 0 1 7.666-3.282c.134 1.414.22 2.843.255 4.284a.75.75 0 0 1-.46.711 47.87 47.87 0 0 0-8.105 4.342.75.75 0 0 1-.832 0 47.87 47.87 0 0 0-8.104-4.342.75.75 0 0 1-.461-.71c.035-1.442.121-2.87.255-4.286.921.304 1.83.634 2.726.99v1.27a1.5 1.5 0 0 0-.14 2.508c-.09.38-.222.753-.397 1.11.452.213.901.434 1.346.66a6.727 6.727 0 0 0 .551-1.607 1.5 1.5 0 0 0 .14-2.67v-.645a48.549 48.549 0 0 1 3.44 1.667 2.25 2.25 0 0 0 2.12 0Z" />
                <path d="M4.462 19.462c.42-.419.753-.89 1-1.395.453.214.902.435 1.347.662a6.742 6.742 0 0 1-1.286 1.794.75.75 0 0 1-1.06-1.06Z" />
              </svg>
            )}
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        {/* Time  */}
        <h1 className="text-center self-start bg-slate-700 px-2 py-1 rounded-full font-bold text-xs">
          {duration}
        </h1>
        <div className="flex gap-0 flex-col">
          {/* Title */}
          <h1 className="font-bold text-xl"> {title} </h1>
          <a href={link} target="_blank" rel="noreferrer">
            <h1 className="text-slate-400">{firm}</h1>
          </a>
          {/* Description */}
          <p className="text-sm">{description}</p>
        </div>
      </div>
    </div>
  );
}

function SocialLink({social}) {
  let { link, name, img } = social;
  return (
    <a
      href={link}
      className="hover:w-12 w-10 transition-all"
      target="_blank"
      rel="noreferrer"
    >
      <div className="w-full flex justify-center items-center flex-col">
        <img className="w-full" src={img} alt={name}></img>
        {/* <h3 className="text-white pt-3">{name}</h3> */}
      </div>
    </a>
  );
}
